import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ReactGA from 'react-ga4';
import Auth from '../services/auth';
import { guideUrls } from '../shared/guideUrls';
import YoutubeDataAccess from '../services/youtubeDataAccess';
import CircularProgress from '@material-ui/core/CircularProgress';
import DocumentArchiveRequest from '../Pages/SupportRequestForm/SupportRequestForm';
const youtubeDataAccess = new YoutubeDataAccess();

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(3),
    }),
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    incompleteCard: {
        minWidth: 240,
        height: 145,
        borderLeft: '6px solid red'
    },
    openCard: {
        minWidth: 240,
        height: 145,
        borderLeft: '6px solid yellow'
    },
    completeQuestionsCard: {
        minWidth: 240,
        height: 145,
        borderLeft: '6px solid blue'
    }
    , completeCard: {
        minWidth: 240,
        height: 145,
        borderLeft: '6px solid green'
    },
    tatCard: {
        height: 250
    },
    tatCardReason: {
        height: 75
    }
});


class Help extends Component {
    displayName = Help.name
    constructor(props) {
        super(props);
        this.state = {
            youtubeList:
            {
                playlistName: "",
                videos: [{
                    title: "",
                    url: ""
                }]
            },
            youtubeList2: [{
                title: "",
                url: ""
            }],
            isLoading: true,
        };
        this.loadingYoutubeList = this.loadingYoutubeList.bind(this);
    }
    onClassicView = () => {
        const auth = new Auth();
        ReactGA.event({
            action: 'Classic Portal',
            category: `${auth.getGaUser()}`
        });
    }
    componentWillMount() {
        this.loadingYoutubeList();
    }

    loadingYoutubeList() {
        var self = this;
        self.setState({ isLoading: true });
        var playlistOne = youtubeDataAccess.getPlaylist("SNChart Training Videos","PLFGH288kCYNNXw7uTdgGV9ghjiQJC_HfV");
        var playlistTwo = youtubeDataAccess.getPlaylist("SNChart Monthly Client Trainings","PLFGH288kCYNPFBKhvibIkKMKw_lMPLtMT");

        Promise.all([playlistOne, playlistTwo]).then(function (values) {
            self.setState({ youtubeList: values[1], youtubeList2: values[0], isLoading: false });
        }).catch(error => {
        });
        
    }
    render() {
        const { mobileUserGuide, userGuide, quickReferenceGuide, esignDoc} = guideUrls;
        const { youtubeList, youtubeList2 } = this.state;
        return (
            <div>
                <Typography variant="h2" gutterBottom>
                    Help
      </Typography>

                <Card>
                    <CardContent>

                        <Grid container spacing={3} justify='space-between'>

                            <Grid item xs={12} lg={4} md={4}>
                                <Typography variant="h5" gutterBottom>
                                    How to's
      </Typography>
                                <List>
                                    <ListItem button component="a" target="_blank" href={userGuide}>
                                        <ListItemText primary="User Manual (Web)" />
                                    </ListItem>
                                    <ListItem button component="a" target="_blank" href={mobileUserGuide}>
                                        <ListItemText primary="User Manual (Mobile)" />
                                    </ListItem>
                                    <ListItem button component="a" target="_blank" href={quickReferenceGuide}>
                                        <ListItemText primary="Dictation Quick Reference Guide" />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item xs={12} lg={4} md={4}>
                                <Typography variant="h5" gutterBottom>
                                    FAQ's
      </Typography>
                                <List>
                                    <ListItem button component={Link} to='/ChangePassword'>
                                        <ListItemText
                                            primary="Change Password"
                                        />
                                    </ListItem>
                                    <ListItem button component={Link} to='/support-request'>
                                        <ListItemText
                                            primary="Support Request Form"
                                        />
                                    </ListItem>
                                    <ListItem button component="a" target="_blank" href={esignDoc}>
                                        <ListItemText
                                            primary="E-Signature Forms"
                                        />
                                    </ListItem>
                                </List>

                            </Grid>
                            <Grid item xs={12} lg={4} md={4}>

                                <List>

                                    <Typography variant="h5" gutterBottom>
                                        Contact
                                    </Typography>

                                    <ListItem button component="a" target="_blank" href="mailto:AcctMgrs@surgicalnotes.com">
                                        <ListItemText
                                            primary="Account Manager Team"
                                        />
                                    </ListItem>
                                    <ListItem button component="a" target="_blank" href="tel:1-800-866-0656">
                                        <ListItemText
                                            primary="(800) 866-0656"
                                        />
                                    </ListItem>

                                </List>

                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h5" gutterBottom>
                                    Training Videos
      </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    {youtubeList.playlistName}
                                </Typography>
                            </Grid>
                            {this.state.isLoading && <CircularProgress />}
                            {!this.state.isLoading && youtubeList.videos.map((video, key) => (

                                <Grid id={key} item xs={12} md={4} >
                                    <Typography variant="subtitle1">
                                            {video.title.length >= 65 ? `${video.title.substring(0, 65)}...` : video.title}
                                    </Typography>

                                        <div style={{ position: "relative", height: 0, overflow: "hidden", maxWidth: "100%", paddingBottom: "56.25%" }}>

                                            <iframe title={video.title}
                                                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                                                src={video.url} frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                        </div>
                                    </Grid>
                                
                            ))}
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    {youtubeList2.playlistName}
      </Typography>
                            </Grid>
                            {this.state.isLoading && <CircularProgress />}
                            {!this.state.isLoading && youtubeList2.videos.map((video, key) => (

                                <Grid id={key} item xs={12} md={4} >
                                    <Typography variant="subtitle1">{video.title}</Typography>

                                    <div style={{ position: "relative", height: 0, overflow: "hidden", maxWidth: "100%", paddingBottom: "56.25%" }}>

                                        <iframe title={video.title}
                                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                                            src={video.url} frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                    </div>
                                </Grid>

                            ))}



                            
                            
   </Grid>

                            </CardContent>
                        </Card>





            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Help);



// WEBPACK FOOTER //
// ./src/components/Help.js